import { Modal, Button, Box, ModalProps, Text, Stack } from '@mantine/core';
import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

export type RestoreFormDataModalProps = ModalProps & {
  onRestore: MouseEventHandler;
};

/**
 * RestoreFormDataModal
 * This component is used to display a modal for restoring form data.
 *
 * @param onClose - Function to call when modal is closed
 * @param onRestore - Function to call when user wants to restore data
 * @param props - ModalProps
 */
export const RestoreFormDataModal: React.FC<RestoreFormDataModalProps> = ({
  onClose,
  onRestore,
  ...props
}) => {
  const { t } = useTranslation(['forms']);

  return (
    <Modal
      title={t('restoreData.title')}
      size="lg"
      onClose={onClose}
      {...props}
    >
      <Stack spacing="lg">
        <Stack>
          <Text>{t('restoreData.line1')}</Text>
          <Text>{t('restoreData.line2')}</Text>
        </Stack>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row-reverse',
            gap: '8px',
          }}
        >
          <Button onClick={onRestore}>{t('restoreDate.cta')}</Button>
          <Button variant="default" onClick={onClose}>
            {t('restoreDate.ignore')}
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};
